import type { LoaderFunctionArgs } from "react-router"
import { replace } from "react-router"

import { RootPath } from "@/models/route"
import { loadOrganizationResolutionContext } from "@/utils/organization/organization-loader-context"
import { resolveLoaderError } from "@/utils/route-loader-error"

export const rootIndexLoader = async ({
  request,
}: LoaderFunctionArgs): Promise<Response | null> => {
  try {
    const context = await loadOrganizationResolutionContext(undefined)

    if (!context?.resolvedOrganizationId) {
      return null
    }

    return replace(`/${context.resolvedOrganizationId}/${RootPath.Report}`)
  } catch (error: unknown) {
    return resolveLoaderError(error, request)
  }
}
